var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",class:{ block: _vm.type === 'block', top: _vm.align === 'top', bottom: _vm.align === 'bottom' }},[_c('img',{attrs:{"src":require("@/assets/common/ui/loading.gif"),"width":"200","height":"230"}})])}
var staticRenderFns = []

export { render, staticRenderFns }